var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contentContainer"},[_c('h2',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.titleLeft)+" "),_c('span',{staticClass:"titleSpanColor"},[_vm._v(_vm._s(_vm.titleRight))])]),_c('p',{staticClass:"description"},[_vm._v(" "+_vm._s(_vm.description)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }